import { render, staticRenderFns } from "./UserEditPhoneModal.vue?vue&type=template&id=967bc06a&scoped=true&"
import script from "./UserEditPhoneModal.vue?vue&type=script&lang=js&"
export * from "./UserEditPhoneModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967bc06a",
  null
  
)

export default component.exports